import { HttpContextToken } from '@angular/common/http';
import { LoaderMode, LoaderScope } from '../models/loading.models';

export const LOADER_MODE_CONTEXT = new HttpContextToken<LoaderMode | null>(() => null);
export const LOADER_SCOPE_CONTEXT = new HttpContextToken<LoaderScope | null>(() => null);
export const LOADER_GROUP_CONTEXT = new HttpContextToken<string | null>(() => null);
export const LOADER_SKIP_CONTEXT = new HttpContextToken<boolean>(() => false);
export const LOADER_MESSAGE_CONTEXT = new HttpContextToken<string | null>(() => null);
export const LOADER_PRIORITY_CONTEXT = new HttpContextToken<number | null>(() => null);
export const LOADER_REFERENCE_CONTEXT = new HttpContextToken<string | null>(() => null);
export const LOADER_ROUTE_KEY_CONTEXT = new HttpContextToken<string | null>(() => null);
export const LOADER_MODULE_KEY_CONTEXT = new HttpContextToken<string | null>(() => null);
